"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _urlCatalog = _interopRequireDefault(require("@angi/url-catalog"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var logo = require('./AngiLogo.png');

var getFooterConfig = function getFooterConfig(_ref) {
  var isAuth = _ref.isAuth,
      isAdvertiser = _ref.isAdvertiser,
      spId = _ref.spId,
      isAngiLeads = _ref.isAngiLeads,
      isUnifiedHeader = _ref.isUnifiedHeader,
      businessCenterPhone = _ref.businessCenterPhone,
      isInboxEnabled = _ref.isInboxEnabled;
  var footerConfig = {};
  var customerCarePhone;
  var customerCarePhoneText;

  if (businessCenterPhone) {
    customerCarePhone = businessCenterPhone.tel;
    customerCarePhoneText = businessCenterPhone.text;
  } else if (isAngiLeads === true) {
    customerCarePhone = _urlCatalog["default"].global.customerCarePhone();
    customerCarePhoneText = _urlCatalog["default"].global.customerCarePhoneText();
  } else {
    customerCarePhone = _urlCatalog["default"].global.businessCenterPhone();
    customerCarePhoneText = _urlCatalog["default"].global.businessCenterPhoneText();
  }

  var businessEmail = _urlCatalog["default"].global.businessCenterEmail();

  if (isAuth) {
    var baseSiteMap = {
      'We\'re here to help': _objectSpread((0, _defineProperty2["default"])({}, "Call ".concat(customerCarePhoneText), {
        href: customerCarePhone,
        id: 'business-center-phone',
        'data-track-description': 'Support phone number clicked',
        'data-track-phonenumber': customerCarePhoneText,
        title: 'Call us toll free from Monday through Friday, 8 AM - 8 PM EST'
      }), isAngiLeads ? {} : (0, _defineProperty2["default"])({}, "".concat(businessEmail), {
        href: "mailto:".concat(businessEmail),
        id: 'business-center-email',
        'data-track-description': 'Support email clicked',
        title: 'Click to email'
      }))
    };
    var angiAdsProPerks = isAdvertiser ? {
      'Pro Perks': {
        href: _urlCatalog["default"].office.proPerks(),
        target: '_blank',
        id: 'footer-proPerks',
        'data-track-description': 'Pro Perks'
      }
    } : {};
    var angiLeadsProPerks = {
      'Pro Perks': {
        href: _urlCatalog["default"].office.proPerks(),
        target: '_blank',
        id: 'footer-proPerks',
        'data-track-description': 'Pro Perks'
      }
    };
    var proInbox = {
      Messages: {
        href: _urlCatalog["default"].office.ads.inbox(spId),
        id: 'footer-messages',
        'data-track-description': 'Messages'
      }
    };
    var angiAdsFAQLink = isAdvertiser ? {
      'FAQ and resource center': {
        href: _urlCatalog["default"].global.intercomAssistance(),
        id: 'footer-faqs',
        'data-track-description': 'FAQ and resource center'
      }
    } : {};

    var angiAdsSiteMap = _objectSpread({
      Angi: _objectSpread(_objectSpread({
        Home: {
          href: _urlCatalog["default"].office.ads.home(spId),
          id: 'footer-home',
          'data-track-description': 'Home'
        },
        Leads: {
          href: _urlCatalog["default"].office.ads.leadBoard(spId),
          id: 'footer-leads',
          'data-track-description': 'Leads'
        },
        Reviews: {
          href: _urlCatalog["default"].office.ads.reviews(spId),
          id: 'footer-reviews',
          'data-track-description': 'Reviews'
        }
      }, isInboxEnabled ? proInbox : {}), isUnifiedHeader ? angiAdsProPerks : {}),
      'Settings and support': _objectSpread({
        'Business profile': {
          href: _urlCatalog["default"].office.spProfile.edit(spId),
          id: 'footer-settings',
          'data-track-description': 'Business settings'
        },
        'Personal settings': {
          href: _urlCatalog["default"].office.account.home(),
          id: 'footer-account',
          'data-track-description': 'Personal settings'
        }
      }, angiAdsFAQLink)
    }, baseSiteMap);

    var angiLeadsSiteMap = _objectSpread({
      Angi: _objectSpread({
        Home: {
          href: _urlCatalog["default"].office.leads.homePage(spId),
          id: 'footer-home',
          'data-track-description': 'Home'
        },
        Leads: {
          href: _urlCatalog["default"].office.leads.leadsBoard(spId),
          id: 'footer-leads',
          'data-track-description': 'Leads'
        },
        Opportunities: {
          href: _urlCatalog["default"].office.leads.opportunities(spId),
          id: 'footer-opportunities',
          'data-track-description': 'Opportunities'
        },
        Reviews: {
          href: _urlCatalog["default"].office.leads.reviews(spId),
          id: 'footer-reviews',
          'data-track-description': 'Reviews'
        }
      }, angiLeadsProPerks),
      'Settings and support': {
        'Adjust your service locations': {
          href: _urlCatalog["default"].office.leads.serviceArea(spId),
          id: 'footer-service-area',
          'data-track-description': 'Adjust your service locations'
        },
        'Adjust your services and tasks': {
          href: _urlCatalog["default"].office.leads.servicesOffered(spId),
          id: 'footer-services',
          'data-track-description': 'Adjust your services and tasks'
        },
        'Personal settings': {
          href: _urlCatalog["default"].office.account.home(),
          id: 'footer-settings',
          'data-track-description': 'Personal settings'
        },
        'FAQ and resource center': {
          href: _urlCatalog["default"].global.intercomAssistance(),
          id: 'footer-faqs',
          'data-track-description': 'FAQ and resource center'
        }
      }
    }, baseSiteMap);

    var siteMap;

    if (spId) {
      siteMap = isAngiLeads ? angiLeadsSiteMap : angiAdsSiteMap;
    } else {
      siteMap = baseSiteMap;
    }

    footerConfig = {
      homeLink: '/',
      logo: logo,
      copyrightLinks: {
        'Angi Pro Terms (Enrollment Post 9/26/23)': {
          href: _urlCatalog["default"].global.unifiedAngiProTerms(),
          'data-track-description': 'Terms of Use'
        },
        'Privacy Policy': {
          href: _urlCatalog["default"].global.privacyPolicy(),
          'data-track-description': 'Privacy Policy'
        },
        'Service Provider Agreement': {
          href: _urlCatalog["default"].global.serviceProviderUserAgreement(),
          'data-track-description': 'Service Provider Agreement'
        },
        'California Privacy': {
          href: _urlCatalog["default"].global.californiaConsumerPrivacyAct(),
          'data-track-description': 'California Privacy'
        }
      },
      contactInfo: {
        phone: _urlCatalog["default"].global.businessCenterPhoneText(),
        hours: 'M-F: 8:00am - 8:00pm EST'
      },
      sitemap: siteMap
    };
  } else {
    footerConfig = {
      copyrightLinks: {
        'Angi Pro Terms (Enrollment Post 9/26/23)': {
          href: _urlCatalog["default"].global.unifiedAngiProTerms(),
          'data-track-description': 'Terms of Use'
        },
        'Privacy Policy': {
          href: _urlCatalog["default"].global.privacyPolicy(),
          'data-track-description': 'Privacy Policy'
        },
        'California Privacy': {
          href: _urlCatalog["default"].global.californiaConsumerPrivacyAct(),
          'data-track-description': 'California Privacy link'
        }
      }
    };
  }

  return footerConfig;
};

var _default = getFooterConfig;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/v1/footer/footerConfig.js
// module id = 3650
// module chunks = 25